/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatMessageListColumn.vue?vue&type=template&id=1f8c24fc"
import script from "./ChatMessageListColumn.vue?vue&type=script&lang=js"
export * from "./ChatMessageListColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8c24fc')) {
      api.createRecord('1f8c24fc', component.options)
    } else {
      api.reload('1f8c24fc', component.options)
    }
    module.hot.accept("./ChatMessageListColumn.vue?vue&type=template&id=1f8c24fc", function () {
      api.rerender('1f8c24fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatMessageListColumn.vue"
export default component.exports